import { Platform } from 'react-native';
import { proxy } from '../../../../globalVars/data';
import {
  collection,
  getCountFromServer,
  getDoc,
  getDocs,
} from 'firebase/firestore';
import { getDocsTool } from '../../../functions/firebase/getDocs';
import { firestoreOutFlax } from '../../../functions/firebase/firebase';

export const getDBLocationData = async (id: string) => {
  let numBikes = '0';

  const refCol = collection(firestoreOutFlax, 'locations', id, 'localBikes');
  //   const resItemDbData = await getDocs(refCol);

  const countDocs = await getCountFromServer(refCol);

  if (countDocs) {
    numBikes = String(countDocs.data().count);
  }
  console.log({ resItemDbData: numBikes });

  return String(numBikes);
};
